import { filterByLabel } from "@/lib/filterByLabel";
import { DropdownService } from "@/services/APIs";
import { useQuery } from "@tanstack/react-query";
import { Checkbox, Col, Form, Input, Row, Select } from "antd";
import { useEffect } from "react";

const { TextArea } = Input;

interface WorkflowInfoFormProps {
  form: any;
  isEditMode: boolean;
  workflow?: any;
  disabled?: boolean;
}

const WorkflowInfoForm = ({
  form,
  isEditMode,
  workflow,
  disabled = false,
}: WorkflowInfoFormProps) => {
  const { data: schemaOptions, isLoading: schemaLoading } = useQuery({
    queryKey: ["schema"],
    queryFn: () => DropdownService.getDropdownData("schema"),
  });

  // Load workflow data in edit mode
  useEffect(() => {
    if (isEditMode && workflow) {
      // Set form fields
      form.setFieldsValue({
        name: workflow.name,
        description: workflow.description,
        schema_name: workflow.schema_name,
        is_default: workflow.is_default,
      });
    }
  }, [isEditMode, workflow, form]);

  return (
    <Form form={form} layout="vertical">
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="name"
            label="Workflow Name"
            rules={[{ required: true, message: "Please enter workflow name" }]}
          >
            <Input placeholder="Enter workflow name" disabled={disabled} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="schema_name"
            label="Schema"
            rules={[{ required: true, message: "Please select a schema" }]}
          >
            <Select
              placeholder="Select schema"
              showSearch
              filterOption={filterByLabel}
              disabled={isEditMode ?? disabled}
              options={schemaOptions}
              loading={schemaLoading}
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="description" label="Description">
        <TextArea
          placeholder="Enter workflow description"
          rows={3}
          disabled={disabled}
        />
      </Form.Item>
      <Col span={12}>
        <Form.Item
          name="is_default"
          valuePropName="checked"
          style={{ marginTop: 20 }}
        >
          <Checkbox>Default Workflow</Checkbox>
        </Form.Item>
      </Col>
    </Form>
  );
};

export default WorkflowInfoForm;
